import { render, staticRenderFns } from "./FileViewerZip.vue?vue&type=template&id=077c9c50&scoped=true&"
import script from "./FileViewerZip.vue?vue&type=script&lang=js&"
export * from "./FileViewerZip.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerZip.vue?vue&type=style&index=0&id=077c9c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c9c50",
  null
  
)

export default component.exports